import React from 'react';
import styled from 'styled-components';
import { Typography } from '../Typography';

interface ColoredTwoLineCardWrapperProps {
    variant: 'primary' | 'success' | 'error';
}

export const backgroundColorMap = {
    primary: '#19AEFF29',
    success: '#39CB8529',
    error: '#F64C6229',
};

export const HighlightedInfoWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    ${({ theme }) => `
        ${theme.breakpoints.up('sm')} {
            margin: 0 -${theme.spacing(1)}px;
        }
    `}
`;

export const HighlightedInfoItemWrapper = styled.div<{ overflow?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    ${({ theme, overflow }) => `
        margin-bottom: ${theme.spacing(2)}px;
        ${theme.breakpoints.up('sm')} {
            width: ${overflow ? 'max-content' : '200px'};
            margin: 0 ${theme.spacing(1)}px ${theme.spacing(2)}px;
        }
    `}
`;

const ColoredTwoLineCardWrapper = styled.div<ColoredTwoLineCardWrapperProps>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    padding: ${props => props.theme.spacing(1.5)}px;
    border-radius: 10px;
    background: ${props => backgroundColorMap[props.variant]};
`;

interface ColoredTwoLineCardProps extends ColoredTwoLineCardWrapperProps {
    label: string;
    value: React.ReactNode;
}


const ColoredTwoLineCard = ({ variant, label, value }: ColoredTwoLineCardProps) => {

    return (
        <ColoredTwoLineCardWrapper variant={variant}>
            <Typography colorVariant={variant} variant="overline">{label}</Typography>
            <Typography variant="subtitle1" noWrap>{value}</Typography>
        </ColoredTwoLineCardWrapper>
    );
};

export default ColoredTwoLineCard;
